<template>
	<header class="header">
		<div class="header-wrapper">
			<div class="header-left">
				<MenuIcon @click="toggleNavBar" class="toggle-menu-icon" v-if="!navBarVisibility" />
				<h2 class="dashboard-title" v-if="assignUserStatus && !navBarVisibility">Assign Student</h2>
				<h2 class="dashboard-title" v-if="!navBarVisibility && !assignUserStatus">{{ transformedTitle }}</h2>
			</div>
			<div>
				<router-link
					v-if="getLinkByCurrentRoute()"
					class="header-navigation"
					:to="getLinkByCurrentRoute() ? getLinkByCurrentRoute().path : ''"
				>{{ getLinkByCurrentRoute().label }}
				</router-link>
			</div>
		</div>
		<Breadcrumbs />
	</header>
</template>

<script>
import Breadcrumbs from '../common/Breadcrumbs'
import MenuIcon from 'vue-material-design-icons/Menu.vue'

export default {
	props: ['title', 'navBarVisibility', 'assignUserStatus'],
	name: "dashboardHeader",
	components: {
		MenuIcon,
		Breadcrumbs
	},
	computed: {
		transformedTitle() {
			return this.title.charAt(0).toUpperCase() + this.title.slice(1)
		},
	},
	updated() {
		if (this.$route.name) {
			document.title = `${this.$route.name} - Check and Train`
		} else {
			document.title = `Check and Train`
		}
	},
	methods: {
		toggleNavBar() {
			this.$emit('toggleNavBar');
		},
		getLinkByCurrentRoute() {
			const {
				courseTemplateId,
				elementTemplateId,
				lessonTemplateId,
				unitTemplateId
			} = this.$route.params
			if (this.$route.name === 'View Users') {
				return {
						path: '/user/add',
						label: 'Add User'
					}
			}

			if (this.$route.name === 'Course Templates') {
				return {
						path: '/template/add',
						label: 'Add Course'
				}
			}

			if (this.$route.name === 'Lessons') {
				return {
						path: `/templates/${courseTemplateId}/lessons/add`,
						label: 'Add Lesson'
				}
			}

			if (this.$route.name === 'Units') {
				return {
						path: `/templates/${courseTemplateId}/lessons/${lessonTemplateId}/unit/add`,
						label: 'Add Unit'
				}
			}

			if (this.$route.name === 'Elements') {
				return {
						path: `/templates/${courseTemplateId}/lessons/${lessonTemplateId}/units/${unitTemplateId}/element/add`,
						label: 'Add Element'
				}
			}

			if (this.$route.name === 'View Courses') {
				return {
					path: 'course-assign',
					label: 'Add Student to Course'
				}
			}

			if (this.$route.name === 'Criteria') {
			const path = `/templates/${courseTemplateId}/lessons/${lessonTemplateId}/units/${unitTemplateId}/elements/${elementTemplateId}/criteria/add`
				return {
						path,
						label: 'Add Criteria'
				}
			}

			return false
		}
	}
}
</script>

<style scoped lang="scss">

.toggle-menu-icon {
	cursor: pointer;

	svg,
	svg path {
		color: #0275ff;
	}
}

header.header {
	padding: 25px 45px;
	background-color: white;
	color: white;
	display: flex;
	align-items: center;
	flex-direction: column;

	.header-wrapper {
		width: 100%;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		min-height: 66px;
	}

	.header-left {
		display: flex;
		align-items: center;
	}

	.header-navigation {
		background-color: #08ce97;
		border-style: none;
		color: #fff;
		outline: none;
		height: 30px;
		padding-right: 2em;
		padding-left: 2em;
		border-radius: 0.75em;
		display: flex;
		flex-direction: row;
		align-items: center;

		&:after {
			content: "+";
			margin-left: .25em;
			margin-bottom: .1em;
			font-weight: 900;
			font-size: 2em;
		}
	}

	.toggle-menu-icon {
		color: #0275ff;
		background-color: rgba(0,116,255,.05);
		border-radius: 50%;
		padding: 0;
		height: 50px;
		width: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: 10px;
	}


	.dashboard-title {
		font-weight: bold;
		color: black;
		text-align: left;
	}
}
</style>
